import {createStyles, makeStyles} from "@material-ui/core/styles";

const FeatureStyles = makeStyles(() =>
  createStyles({
    container: {
      display: "flex",
      flexGrow: 1,
    },
  }),
);

export default FeatureStyles;
